var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid p-0 home-bg"},[_c('div',{staticClass:"row vtmar-container"},[_c('div',{staticClass:"col-6 col-sm-5 col-md-4 col-lg-3 col-xl-3 p-0 h-100"},[_c('vtpanel')],1),_c('div',{staticClass:"col-6 col-sm-7 col-md-8 col-lg-9 col-xl-9 p-0 h-100"},[_c('papersList')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }